import React from 'react';
import { GenericRadio } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import { isRequired } from '../../../utils/validation';

const Control = ({ values }) => (
  <Content>
    {({
      signatoriesAndShareholdersControlLabel,
      signatoriesAndShareholdersControlValue1,
      signatoriesAndShareholdersControlValue2,
      globalRadioError
    }) => (
      <Field name="control" subscription={{ touched: true, error: true }} validate={isRequired}>
        {({ meta: { touched, error }, input }) => (
          <GenericFieldWrapper
            inputId="control"
            title={signatoriesAndShareholdersControlLabel}
            validationMessage={touched && !!error ? globalRadioError : ''}
          >
            <GenericRadio.InlineSet
              groupName="control"
              items={[
                {
                  id: 'Y',
                  labelText: signatoriesAndShareholdersControlValue1
                },
                {
                  id: 'N',
                  labelText: signatoriesAndShareholdersControlValue2
                }
              ]}
              {...input}
              selectedId={values.control}
            />
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);
export default Control;
